// RetencionesCOTabXL - Sprint 44 Fase 3 Vista 2.
// 4 retenciones booleanas aplicables al cliente (Colombia):
//   retencion_fuente, retencion_iva, retencion_ica, autorretencion.
// Nota: tasas de retencion y aplicacion en ventas son Fase 2 Backend S45.
// Aca solo marcamos los flags (comportamiento igual al legacy).
import { useEffect } from 'react';
import { ensureKeyframes, injectCSS } from '../../../design/motion';
import XLCheck from '../../../components/xl/XLCheck';
import { esColombia } from '../../clientes/form/utils';

const CSS_ID = 'xl-cli-ret-co-css';
const CSS = `
.xl-cli-ret {
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 560px;
}
.xl-cli-ret__note {
  background: rgba(37,99,235,0.08);
  border: 1px solid rgba(37,99,235,0.22);
  color: var(--xl-color-info);
  border-radius: var(--xl-radius-md);
  padding: 10px 12px;
  font-size: 13px;
  line-height: 1.45;
  font-family: var(--xl-font-sans);
}
[data-xl-theme="dark"] .xl-cli-ret__note {
  background: rgba(96,165,250,0.14);
  border-color: rgba(96,165,250,0.32);
}
.xl-cli-ret__off {
  padding: 16px;
  color: var(--xl-color-text-muted);
  font-size: 13px;
  font-family: var(--xl-font-sans);
}
.xl-cli-ret__list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
`;

export default function RetencionesCOTabXL({ form, set }) {
  useEffect(() => {
    ensureKeyframes();
    injectCSS(CSS_ID, CSS);
  }, []);

  if (!esColombia(form.pais)) {
    return (
      <div className="xl-cli-ret__off" role="note">
        Este tab solo aplica cuando el pais es Colombia.
      </div>
    );
  }

  return (
    <div className="xl-cli-ret">
      <div className="xl-cli-ret__note" role="note">
        Marca las retenciones aplicables a este cliente. Las tasas y el
        asiento contable de retencion se configuran en el sprint de backend
        S45 (fase 2 - IVA por tasa + retenciones).
      </div>

      <div className="xl-cli-ret__list">
        <XLCheck
          checked={!!form.retencion_fuente}
          onChange={(v) => set('retencion_fuente', v)}
          label="Retencion en la fuente"
        />
        <XLCheck
          checked={!!form.retencion_iva}
          onChange={(v) => set('retencion_iva', v)}
          label="Retencion de IVA (ReteIVA)"
        />
        <XLCheck
          checked={!!form.retencion_ica}
          onChange={(v) => set('retencion_ica', v)}
          label="Retencion de ICA (ReteICA)"
        />
        <XLCheck
          checked={!!form.autorretencion}
          onChange={(v) => set('autorretencion', v)}
          label="Autorretenedor"
        />
      </div>
    </div>
  );
}
